import React, { useState, useEffect } from 'react';
import "./Dashboard.css"
import { BiLogoZoom } from "react-icons/bi";
import { FaUsers } from "react-icons/fa6";
import { Col, Container, Row } from 'react-bootstrap';
import DashboardGraph from '../../Components/DashboardGraph/DashboardGraph';
import UserTable from '../../Components/UserTable/UserTable';

const Dashboard = () => {
  const [dynamicData, setDynamicData] = useState([]);
  const [registeredUsers] = useState([]);
  const [totals, setTotals] = useState({
    mentors: 0,
    mentees: 0,
    registeredUsers: 0,
    upcomingMeetings: 0,
  });

  // Function to fetch appointments data
  const fetchDynamicData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/admin/getgraphData`);
      if (!response.ok) throw new Error('Failed to fetch appointments data');
  
      const graphData = await response.json();
      console.log("graphData==>>", graphData);
  
      if (Array.isArray(graphData?.data)) {
        setDynamicData(graphData.data);
  
        const now = new Date();
        const futureMeetings = graphData.data.filter(item => {
          if (!item.month) return false;
          const itemDate = new Date(`${item.month}, ${now.getFullYear()}`); 
          return itemDate >= now;
        });
        const totalUpcomingMeetings = futureMeetings.reduce((sum, item) => sum + (item.meetings || 0), 0);
  
        // console.log("Filtered futureMeetings:", futureMeetings);
        // console.log("Total Upcoming Meetings:", totalUpcomingMeetings);
  
        setTotals(prev => ({
          ...prev,
          upcomingMeetings: totalUpcomingMeetings
        }));
      }
    } catch (error) {
      console.error('Error fetching appointments data:', error.message);
    }
  };
  
  



  // Function to fetch user data (mentors, mentees, and registered users count)
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch users data
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/admin/getAlluser`);
        const result = await response.json();
          console.log("totaluser", result);
        if (response.ok) {
          // Count mentors and mentees from result.users
          const mentorsCount = result.users.filter((user) => user.userType === 1).length; // Mentors
          const menteesCount = result.users.filter((user) => user.userType === 0).length; // Mentees
          const verifiedUsersCount = result.users.filter(user => user.isVerified === 1).length;


          // Update totals state
          setTotals((prevTotals) => ({
            ...prevTotals,
            mentors: mentorsCount,
            mentees: menteesCount,
            registeredUsers: verifiedUsersCount || 0,
          }));
        } else {
          console.error('Failed to fetch data:', result.message);
        }

        // Fetch upcoming meetings date
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Fetch dynamic data on component mount
  useEffect(() => {
    fetchDynamicData();
  }, []);

  return (
    <>
      <section className='DashboardSec'>
        <Container fluid>
          <div className="DashBordContDiv">

            {/* Card Stats */}
            <div className="TopDashCard">
              <Row>
                <Col md={3}>
                  <div className="CardBoxDiv">
                    <div className="Topcrdview">
                      <div className="lftbox">
                        <p>Total Mentors</p>
                        <h5>{totals.mentors}</h5>
                      </div>
                      <div className="Rytbox">
                        <FaUsers />
                      </div>
                    </div>
                    <hr />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="CardBoxDiv">
                    <div className="Topcrdview">
                      <div className="lftbox">
                        <p>Total Mentees</p>
                        <h5>{totals.mentees}</h5>
                      </div>
                      <div className="Rytbox">
                        <FaUsers />
                      </div>
                    </div>
                    <hr />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="CardBoxDiv">
                    <div className="Topcrdview">
                      <div className="lftbox">
                        <p>Verified Users</p>
                        <h5>{totals.registeredUsers}</h5>
                      </div>
                      <div className="Rytbox">
                        <FaUsers />
                      </div>
                    </div>
                    <hr />
                  </div>
                </Col>
                <Col md={3}>
                  <div className="CardBoxDiv">
                    <div className="Topcrdview">
                      <div className="lftbox">
                        <p>Upcoming Meetings</p>
                        <h5>{totals.upcomingMeetings}</h5>
                      </div>
                      <div className="Rytbox">
                        <BiLogoZoom />
                      </div>
                    </div>
                    <hr />
                  </div>
                </Col>
              </Row>
            </div>

            {/* Dashboard Graph */}
            <div className="DashGraphDiv">
              <Row>
                <Col md={7}>
                  <DashboardGraph data={dynamicData} />
                </Col>
                <Col md={5}>
                  <div className="UpliftMentor">
                    <div className="MentorText">
                      <h4>Get started with Mentor</h4>
                      <p>There’s nothing I really wanted to do in life that I wasn’t able to get good at.</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            {/* User Table */}
            <div className="DashBoardTable">
              <UserTable users={registeredUsers} />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
